import BaseService from '../base-service';
import NetworkUrls from '../network-urls';

class PrivacyPageService extends BaseService {

  async fetch({ lang }) {
    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      data: {
        query: `query ($lang: Lang!) {
    Privacy {
        many {
            title
            item (lang: $lang) {
                content
                }
            }
        }
    }
`,
        variables: { lang }
      }
    };
    return this._exec(config);
  }

  async exportRequest(accessToken) {
    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      headers: {
        Authorization: accessToken,
      },
      data: {
        query: `mutation {
          Privacy {
              exports {
                createRequest {
                  done
                    }
                }
            }
        }`
      }
    };
    return this._exec(config);
  }

  async forgetRequest(accessToken) {
    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      headers: {
        Authorization: accessToken,
      },
      data: {
        query: `mutation {
          Privacy {
              forgets {
                createRequest {
                  done
                    }
                }
            }
        }`
      }
    };
    return this._exec(config);
  }

}
export const privacyPageService = new PrivacyPageService();



// WEBPACK FOOTER //
// ./src/network/services/privacy-page.service.js